import {CaseReducer} from '@reduxjs/toolkit'
import {
    NinchatQueueMemberJoinedEvent,
} from '../types/events'
import {NinchatState} from 'api/types'


import {
    extractProperties,
} from '.'

export const queueMemberJoined: CaseReducer<NinchatState> = (state, action) => {
    const {
        queue_id,
        user_id,
    } = extractProperties<NinchatQueueMemberJoinedEvent>(action.payload)

    if (state.user_id !== user_id && state.user_queues?.[queue_id]) {
        // When someone joined one of my queues
        state.user_queues[queue_id].queue_members = {
            ...state.user_queues?.[queue_id]?.queue_members,
            [user_id]: {
                member_attrs: {},
                user_attrs: state._users?.[user_id]?.user_attrs || {},
            },
        }
    }

    if (state.user_id !== user_id && state._queues?.[queue_id]) {
        // When someone joined one of NOT my queues
        state._queues[queue_id].queue_members = {
            ...state._queues[queue_id].queue_members,
            [user_id]: {
                member_attrs: {},
                user_attrs: state._users?.[user_id]?.user_attrs,
            },
        }
    }
}

